module.exports = __webpack_public_path__ + "static/media/facebookBackground.0db39627.jpg";